const columnWidthClasses = {
  xs: {
    1: 'tw:basis-[8.333333%] tw:max-w-[8.333333%]',
    2: 'tw:basis-[16.666667%] tw:max-w-[16.666667%]',
    3: 'tw:basis-[25%] tw:max-w-[25%]',
    4: 'tw:basis-[33.333333%] tw:max-w-[33.333333%]',
    5: 'tw:basis-[41.666667%] tw:max-w-[41.666667%]',
    6: 'tw:basis-[50%] tw:max-w-[50%]',
    7: 'tw:basis-[58.333333%] tw:max-w-[58.333333%]',
    8: 'tw:basis-[66.666667%] tw:max-w-[66.666667%]',
    9: 'tw:basis-[75%] tw:max-w-[75%]',
    10: 'tw:basis-[83.333333%] tw:max-w-[83.333333%]',
    11: 'tw:basis-[91.666667%] tw:max-w-[91.666667%]',
    12: 'tw:basis-full tw:max-w-full',
  },
  md: {
    1: 'tw:md:basis-[8.333333%] tw:md:max-w-[8.333333%]',
    2: 'tw:md:basis-[16.666667%] tw:md:max-w-[16.666667%]',
    3: 'tw:md:basis-[25%] tw:md:max-w-[25%]',
    4: 'tw:md:basis-[33.333333%] tw:md:max-w-[33.333333%]',
    5: 'tw:md:basis-[41.666667%] tw:md:max-w-[41.666667%]',
    6: 'tw:md:basis-[50%] tw:md:max-w-[50%]',
    7: 'tw:md:basis-[58.333333%] tw:md:max-w-[58.333333%]',
    8: 'tw:md:basis-[66.666667%] tw:md:max-w-[66.666667%]',
    9: 'tw:md:basis-[75%] tw:md:max-w-[75%]',
    10: 'tw:md:basis-[83.333333%] tw:md:max-w-[83.333333%]',
    11: 'tw:md:basis-[91.666667%] tw:md:max-w-[91.666667%]',
    12: 'tw:md:basis-full tw:md:max-w-full',
  },
  lg: {
    1: 'tw:lg:basis-[8.333333%] tw:lg:max-w-[8.333333%]',
    2: 'tw:lg:basis-[16.666667%] tw:lg:max-w-[16.666667%]',
    3: 'tw:lg:basis-[25%] tw:lg:max-w-[25%]',
    4: 'tw:lg:basis-[33.333333%] tw:lg:max-w-[33.333333%]',
    5: 'tw:lg:basis-[41.666667%] tw:lg:max-w-[41.666667%]',
    6: 'tw:lg:basis-[50%] tw:lg:max-w-[50%]',
    7: 'tw:lg:basis-[58.333333%] tw:lg:max-w-[58.333333%]',
    8: 'tw:lg:basis-[66.666667%] tw:lg:max-w-[66.666667%]',
    9: 'tw:lg:basis-[75%] tw:lg:max-w-[75%]',
    10: 'tw:lg:basis-[83.333333%] tw:lg:max-w-[83.333333%]',
    11: 'tw:lg:basis-[91.666667%] tw:lg:max-w-[91.666667%]',
    12: 'tw:lg:basis-full tw:lg:max-w-full',
  },
}

export const getColumnWidth = (breakpoint, value) => value ? columnWidthClasses[breakpoint]?.[String(value)] : null
